import Vue from 'vue'
import moment from "moment";
import firebase from "firebase/app";

Vue.mixin({
    methods: {
        isEmptyOrNull(text) {
            return (text == null || text.toString().trim() === "")
        },
        getAdjustedTitle(currentTitle) {
            if (currentTitle == null) {
                return this.$t('common.not-available')
            }
            const trimmedCurrentTitle = currentTitle.trim()
            if (trimmedCurrentTitle === "") {
                return this.$t('common.not-available')
            }
            return trimmedCurrentTitle
        },
        truncateColumn(text, len = 50) {
            return text.substring(0, len) + (text.length > len ? " ..." : "");
        },
        toFixedIfNecessary(value, dp = 2){
            return +parseFloat(value).toFixed( dp );
        },
        getFullName: function (name) {
            return name.first + " " + name.last
        },
        getFormattedQuantity: function (estimation, unit) {
            if (estimation == null || estimation === "" || estimation === undefined) {
                return ""
            }
            if (estimation.quantity == null || estimation.quantity === "" || estimation.quantity === undefined) {
                return ""
            }
            let u = this.quantityUnits.find(obj => {
                return obj.id === unit
            });
            return this.toFixedIfNecessary(estimation.quantity) + " " + (unit ? this.$t(u.translationAbbrKey) : "")
        },
        getFormattedQuantityEquipment: function (estimation) {
            if (estimation == null || estimation === "" || estimation === undefined) {
                return ""
            }
            if (estimation.quantity == null || estimation.quantity === "" || estimation.quantity === undefined) {
                return ""
            }
            let u = this.quantityUnits.find(obj => {
                return obj.id === this.defaultValues.equipmentQuantityUnitId
            });
            return this.toFixedIfNecessary(estimation.quantity) + " " + this.$t(u.translationAbbrKey)
        },
        getFormattedQuantityValue: function (quantity, unit) {
            if (quantity == null || quantity === "" || quantity === undefined) {
                return ""
            }
            let u = this.quantityUnits.find(obj => {
                return obj.id === unit
            });
            return this.toFixedIfNecessary(quantity) + " " + (unit ? this.$t(u.translationAbbrKey) : "")
        },
        getFormattedFeePerUnit: function (estimation) {
            if (estimation == null || estimation === "" || estimation === undefined) {
                return ""
            }
            return this.getFormattedPricing(estimation.fee_per_unit);
        },
        getFormattedPricing: function (value) {
            if (value == null || value === "" || value === undefined) {
                return ""
            }
            return parseFloat(value).toFixed(2) + " " + this.defaultValues.priceUnit
        },
        getFormattedPricePerDuration: function (value, unit) {
            if (value == null || value === "" || value === undefined) {
                return ""
            }
            let u = this.durationUnits.find(obj => {
                return obj.id === unit
            });
            return parseFloat(value).toFixed(2) + " " + this.defaultValues.priceUnit + "/" + this.$t(u.translationAbbrKey) 
        },
        getFormattedPerformance: function (value, unit) {
            if (value == null || value === "" || value === undefined) {
                return ""
            }
            let u = this.quantityUnits.find(obj => {
                return obj.id === unit
            });
            return this.toFixedIfNecessary(value) + " " + (unit ? this.$t(u.translationAbbrKey) + "/" + this.$t("enums.duration-unit-short.day") : "")
        },
        getPerformanceUnit: function (unit, getAbbr = true) {
            return unit ? this.getTranslatedQuantityUnit(unit, getAbbr) + "/" + this.$t("enums.duration-unit-short.day") : ""
        },
        getTranslatedQuantityUnit: function (unit, getAbbr = true) {
            let u = this.quantityUnits.find(obj => {
                return obj.id === unit
            });
            return unit ? this.$t(getAbbr ? u.translationAbbrKey : u.translationKey) : ""
        },
        getFormattedTime: function (quantity) {
            if (quantity == null || quantity === "" || quantity === undefined) {
                return ""
            }
            const fixedPart = Math.floor(quantity)
            const decimalPart = (quantity % 1).toFixed(2) * 60
            return fixedPart + ":" + (decimalPart === 0 ? "00" : Math.round(decimalPart))
        },
        getFormattedTimeHour: function (quantity) {
            return this.getFormattedTime(quantity) + ' ' + this.$t("enums.duration-unit-short.hour")
        },
        profitTextStyle: function (profit) {
            return {
                color: profit >= 0 ? 'green' : 'red',
                'font-weight': 'bold'
            };
        },
        personalQuantityTextStyle: function (group) {
            if (group === 'internal') {
                return 'internal-text'
            } else {
                return 'external-text'
            }
        },
        isProjectSummaryHoursValid: function (groupedLog) {
            if (groupedLog === null || groupedLog === "" || groupedLog === undefined) {
                return true
            }
            return (groupedLog.total_logged_durations_internal === groupedLog.total_logged_durations_internal_personnel) && (groupedLog.total_logged_durations_external === groupedLog.total_logged_durations_external_personnel)
        },
        isHavingValue(groupedLog) {
            return (groupedLog.total_logged_durations_external !== "" && groupedLog.total_logged_durations_external !== undefined && groupedLog.total_logged_durations_external !== 0) ||
                (groupedLog.total_logged_durations_internal !== "" && groupedLog.total_logged_durations_internal !== undefined && groupedLog.total_logged_durations_internal !== 0) ||
                (groupedLog.total_logged_durations_external_personnel !== "" && groupedLog.total_logged_durations_external_personnel !== undefined && groupedLog.total_logged_durations_external_personnel !== 0) ||
                (groupedLog.total_logged_durations_internal_personnel !== "" && groupedLog.total_logged_durations_internal_personnel !== undefined && groupedLog.total_logged_durations_internal_personnel !== 0)
        },
        getFormattedDate: function (dateString) {
            return moment(dateString).format('L')
        },
        getFormattedDateTime: function (dateString) {
            return moment(dateString).format('LLLL')
        },
        getUserRoleList: function() {
            let userRolesList = [];
            this.userRoleOptions.forEach(element => {
                if(element.id !== "system" || this.currentUserSystemAccessLevel()){
                  userRolesList.push(element);
                }
              });
            return userRolesList;
        },
        hasCurrentUserAccessToUserRole(userRole) {
            return this.currentUserSystemAccessLevel() 
                    || (this.currentUserAdminAccessLevel() && userRole !== "system");
        },
        isCurrentUser(userid) {
            return this.getLocalUserId() === userid;
        },
        getFirebaseStorageError: function (errorCode) {
            switch (errorCode) {
                case 'storage/unauthorized':
                    return this.$t('errors.storage-unauthorized');
                case 'storage/canceled':
                    return this.$t('errors.storage-canceled');
                case 'storage/unknown':
                    return this.$t('errors.storage-unknown');
                case 'storage/invalid-argument':
                    return this.$t('errors.storage-invalid-argument');
                case 'storage/invalid-checksum':
                    return this.$t('errors.storage-invalid-checksum');
                case 'storage/retry-limit-exceeded':
                    return this.$t('errors.storage-retry-limit-exceeded');
                default:
                    return this.$t('errors.storage-default');
            }
        },
        loadUserRoleFromServer,
        getLocalUserRole,
        getLocalUserId,
        getLocalUserSites,
        getLocalUserProjects,
        currentUserEngagedInProject,
        currentUserSystemAccessLevel,
        currentUserAdminAccessLevel,
        currentUserPMAccessLevel,
        currentUserSMAccessLevel,
        currentUserAccess,
        removeUserRole,
        getSubmitEndpoint,
        saveSubmitEndpoint,
        getStorageRootFolder
    }
})

export async function loadUserRoleFromServer() {
    const currentUser = firebase.auth().currentUser;
    if (currentUser === undefined || currentUser === null) {
        return null
    }
    const isEmailVerified = currentUser.emailVerified
    if (!isEmailVerified) {
        return null
    }
    const functions = firebase.app().functions("europe-west3");
    const getUserFunction = functions.httpsCallable(getSubmitEndpoint());
    return await getUserFunction({action: "get_users", filters: [['email', '==', currentUser.email]]})
        .then((result) => {
            const usersData = result.data["users"];
            const currentLoadedUser = usersData[0]
            console.log("current user role is ", currentLoadedUser.roles[0])
            // putting current loaded user role on the local storage
            localStorage.setItem('userRole', currentLoadedUser.roles[0])
            localStorage.setItem('userId', currentLoadedUser.document_id)
            localStorage.setItem('userSites', currentLoadedUser.site_ids)
            localStorage.setItem('userProjects', currentLoadedUser.project_ids)
            return currentLoadedUser.roles[0]
        })
        .catch((error) => {
            if (error.message === "InactiveUser") {
                return "inactive"
            }
        })
}

export function getLocalUserRole() {
    const userRole = localStorage.getItem('userRole')
    if (userRole === undefined || userRole === null || userRole === '') {
        return null
    } else {
        return userRole
    }
}

export function getLocalUserId() {
    const userId = localStorage.getItem('userId')
    if (userId === undefined || userId === null || userId === '') {
        return null
    } else {
        return userId
    }
}

export function getLocalUserSites() {
    const userSites = localStorage.getItem('userSites')
    if (userSites === undefined || userSites === null || userSites === '') {
        return [];
    } else {
        return userSites;
    }
}

export function getLocalUserProjects() {
    const userProjects = localStorage.getItem('userProjects')
    if (userProjects === undefined || userProjects === null || userProjects === '') {
        return [];
    } else {
        return userProjects;
    }
}

export function removeUserRole() {
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    localStorage.removeItem('userSites');
    localStorage.removeItem('userProjects');
    localStorage.removeItem('submit-endpoint');
}

/**
 * The next 4 functions returns the access level of the user not his role.
 * System > Admin > Business/Project Manager > Site Manager
 */
export function currentUserSystemAccessLevel() {
    return (this.getLocalUserRole() === "system");
}

export function currentUserAdminAccessLevel() {
    return (this.getLocalUserRole() === "admin" || this.currentUserSystemAccessLevel());
}

export function currentUserPMAccessLevel() {
    return (this.getLocalUserRole() === "project_manager" || this.currentUserAdminAccessLevel());
}

export function currentUserSMAccessLevel() {
    return (this.getLocalUserRole() === "site_manager" || this.currentUserPMAccessLevel());
}

export function currentUserEngagedInProject(projectId) {
    return this.getLocalUserSites().includes(projectId) || this.getLocalUserProjects().includes(projectId);
}

/**
 * Current user access to different pages
 */
export function currentUserAccess(page, action, projectId, userId) {
    if (page === "Users") {
        return this.currentUserAdminAccessLevel();
    }
    if (page === "UserDetails") {
        return this.getLocalUserId() === userId || this.currentUserAdminAccessLevel();
    }
    if (page === "Projects") {
        if (action === this.UserActions.VIEW)
            return this.currentUserSMAccessLevel();
        if (action === this.UserActions.CREATE)
            return this.currentUserPMAccessLevel();
        if (action === this.UserActions.UPDATE)
            return ((this.currentUserPMAccessLevel() && this.currentUserEngagedInProject(projectId))
                || this.currentUserAdminAccessLevel());
        if (action === this.UserActions.DELETE)
            return this.currentUserAdminAccessLevel();
    }
    if (page === "ProjectDetails") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE)
            return this.currentUserPMAccessLevel();
        if (action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return ((this.currentUserPMAccessLevel() && this.currentUserEngagedInProject(projectId))
                || this.currentUserAdminAccessLevel());
    }
    if (page === "ProjectTemplates") {
        return this.currentUserPMAccessLevel();
    }
    if (page === "ProjectLogs") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE || action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return this.currentUserAdminAccessLevel() || this.currentUserEngagedInProject(projectId);
    }
    if (page === "ProjectSummary") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
    }
    if (page === "TaskDetails") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE || action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return ((this.currentUserPMAccessLevel() && (this.currentUserEngagedInProject(projectId)))
                || this.currentUserAdminAccessLevel());
    }
    if (page === "PersonalDetails") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE || action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return this.currentUserAdminAccessLevel() || this.currentUserEngagedInProject(projectId);
    }
    if (page === "EquipmentDetails") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE || action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return this.currentUserAdminAccessLevel() || this.currentUserEngagedInProject(projectId);
    }
    if (page === "ConsumableDetails") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE || action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return this.currentUserAdminAccessLevel() || this.currentUserEngagedInProject(projectId);
    }
    if (page === "ProjectFilesDetails") {
        if (action === this.UserActions.VIEW)
            return this.currentUserPMAccessLevel() || this.currentUserEngagedInProject(projectId);
        if (action === this.UserActions.CREATE || action === this.UserActions.UPDATE || action === this.UserActions.DELETE)
            return this.currentUserAdminAccessLevel() || this.currentUserEngagedInProject(projectId);
    }
    if (page === "CategoricalData") {
            return this.currentUserSystemAccessLevel() || this.currentUserAdminAccessLevel();
    }

    return false;
}

/**
 * Other mixin functions
 */
export function getSubmitEndpoint() {
    const savedSelectedSubmit = localStorage.getItem("submit-endpoint")
    if (savedSelectedSubmit == null || savedSelectedSubmit === "" || savedSelectedSubmit === undefined) {
        return 'submit';
    } else {
        return savedSelectedSubmit;
    }
}

export function saveSubmitEndpoint(selectedEndpoint) {
    localStorage.setItem("submit-endpoint", selectedEndpoint)
}

export function getStorageRootFolder() {
    const submitEndpoint = getSubmitEndpoint()
    if (submitEndpoint == null || submitEndpoint === "" || submitEndpoint === undefined) {
        return "prod"
    } else {
        if (submitEndpoint === "submit") {
            return "prod"
        } else {
            return "dev"
        }
    }
}